import environment from "../environment";
import posthog from "posthog-js";

const isPosthogEnabledMode = environment.MODE === "production" || environment.MODE === "staging";

export const initializePosthog = () => {
  posthog.init(environment.ATI_PUBLIC_POSTHOG_KEY, {
    autocapture: false,
    // Disable SDK auto-pageview (`defaults: "2026-01-30"` sets this to "history_change").
    // Pageviews are captured manually in App.tsx after the auth guard ensures identify() has been called,
    // so that all events carry the authenticated user's distinct_id instead of an anonymous UUID.
    capture_pageview: false,
    capture_exceptions: false,
    api_host: environment.ATI_PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
    opt_out_capturing_by_default: !isPosthogEnabledMode,
    disable_session_recording: !isPosthogEnabledMode
  });

  if (environment.ATI_TENANT) {
    posthog.group("tenant", environment.ATI_TENANT);
  }

  return posthog;
};
